import styled from "styled-components";
import { borderRadius, borderWidth, spacing, typographyMixin } from "@magicbi/ui-library";

export const Fieldset = styled.fieldset`
  display: grid;
  gap: ${spacing[2]};
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
`;

export const Legend = styled.legend`
  margin-bottom: ${spacing[2]};
  padding: 0;
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Required = styled.span`
  color: ${({ theme }) => theme.colors.error.text};
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));
  gap: ${spacing[3]};
`;

export const Card = styled.label<{ $checked: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${spacing[3]};
  padding: ${spacing[3]} ${spacing[4]};
  border: 1px solid
    ${({ theme, $checked }) => ($checked ? theme.colors.primary[300] : theme.colors.border.subtle)};
  border-radius: ${borderRadius.xl};
  background: ${({ theme, $checked }) =>
    $checked ? theme.colors.background.tertiary : theme.colors.background.primary};
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }
  &:focus-within {
    outline: ${borderWidth[2]} solid ${({ theme }) => theme.colors.interactive.primary};
    outline-offset: ${spacing[0.5]};
  }
`;

export const Check = styled.input`
  flex: none;
  width: 1rem;
  height: 1rem;
  margin: ${spacing[1]} 0 0;
  accent-color: ${({ theme }) => theme.colors.interactive.primary};
`;

export const CardText = styled.span`
  display: grid;
  min-width: 0;
  & > b {
    ${typographyMixin("body", 2)}
    color: ${({ theme }) => theme.colors.text.primary};
  }
  & > span {
    ${typographyMixin("caption", 4)}
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
